export const PROJECT_TYPE_PROPOSAL = '00';
export const PROJECT_TYPE_PROJECT = '01';

export function isProposalProjectType(code?: string | null): boolean {
  return code === PROJECT_TYPE_PROPOSAL;
}
